<template>
	<div class="content">

		<div class="md-layout">
			<div class="md-layout-item md-medium-size-30 md-size-30 md-small-size-0">
			</div>
			<div class="md-layout-item md-medium-size-40 md-size-40 md-small-size-100">

				<md-card>
					<md-card-header data-background-color="purple">

						<h4 class="title"><b>{{$store.state.locale.locale.ticketCheck[$store.state.locale.lang]}}</b></h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<p>{{$store.state.locale.locale.redeemText[$store.state.locale.lang]}}</p>
								<md-field>
									<label>{{$store.state.locale.locale.refCode[$store.state.locale.lang]}}</label>
									<md-input type="text" :value="code.toUpperCase()" v-model="code" spellcheck="false" @keyup="typeEvent()">
									</md-input>
								</md-field>
								<p style="color: red" v-if="String(msg) == 'pending'">{{$store.state.locale.locale.inReview[$store.state.locale.lang]}}</p>
								<p style="color: red" v-if="String(msg) == 'incorrect'">{{$store.state.locale.locale.refInc[$store.state.locale.lang]}}</p>
								<p style="color: red" v-if="String(msg) == 'empty'">{{$store.state.locale.locale.refEmpty[$store.state.locale.lang]}}</p>
								<p style="color: red" v-if="String(msg) == 'notverify'">{{$store.state.locale.locale.refNotVerify[$store.state.locale.lang]}}</p>
								<p style="color: red" v-if="String(msg) == 'reject'">{{$store.state.locale.locale.reject[$store.state.locale.lang]}}</p>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<vue-recaptcha ref="captcha" sitekey="6LcR_tccAAAAAIYbzcQKe4tqan-5i3TxZUJ7D_lv"
									:loadRecaptchaScript="true" @verify="getCapt" @expired="resetCaptcha"></vue-recaptcha>
							</div>

							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-button class="md-primary" style="width:100%" @click="checkValidation()">
									{{$store.state.locale.locale.getTicket[$store.state.locale.lang]}}</md-button>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
</template>

<script>
	import VueRecaptcha from 'vue-recaptcha';
	export default {
		components: { VueRecaptcha },
		data() {
			return {
				msg: "",
				code: "",
				token: ""
			}
		},
		methods: {
			typeEvent(){
				this.msg = "";
				this.code = String(this.code).toLocaleUpperCase();
			},
			redeem() {
				// alert("go");
				this.$http.post(this.config.api + "/public/ticket/redeem", {
					reference_code: this.code,
					token: this.token
				}).then(res => {
					// console.log(res.body.data);
					if (res.body.status == 'success') {
						if(res.body.data.length > 0) {
							if(res.body.data[0].status == "pnd") {
								this.msg = "pending";
							} else if(res.body.data[0].status == "rjt") {
								this.msg = "reject";
							} else {
								this.$router.push("/pass/" + res.body.data[0].hash_id);
							}
						} else {
							this.msg = "incorrect";
						}
					}
					this.resetCaptcha();
				})
			},
			checkValidation() {
				if(String(this.code).length == 0) {
					this.msg = "empty";
					return;
				}
				if (String(this.code).length != 6) {
					this.msg = "incorrect";
					return;
				}
				if (String(this.token).length == 0) {
					this.msg = "notverify";
					return;
				}
				this.redeem();
			},
			getCapt(token) {
				this.token = token;
			},
			resetCaptcha() {
				console.log("reCaptcha reset.")
				this.token = "";
				this.$refs.captcha.reset();
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Redeem.vue